import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2026-09-01T09:01:45-0700.
 */
export function useSrInvoiceBilledStatusEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.SrInvoiceBilledStatus,
    false
  );

  return Boolean(isEnabled);
}
